<template>
  <div>
    <el-input
      v-if="isBannerIdsInput"
      v-model.trim="bannerIds"
      placeholder="Banner ID(s)"
    />

    <template v-else-if="isTitleSeparatorInput">
      <el-input
        v-model="title"
        placeholder="Title"
        class="w-100 mt-1"
      />
      <el-input
        v-model="titleHK"
        placeholder="Title HK"
        class="w-100 mt-1"
      />
      <el-input
        v-model="titleCN"
        placeholder="Title CN"
        class="w-100 mt-1"
      />
      <el-input
        v-model="titleTH"
        placeholder="Title TH"
        class="w-100 mt-1"
      />
      <el-select
        v-model="image"
        placeholder="Icon"
        class="w-100 mt-1"
      >
        <el-option
          v-for="icon in titleSeparatorIcons"
          :key="icon.value"
          :label="icon.label"
          :value="icon.value"
        />
      </el-select>
    </template>

    <span v-else> ------ None ------ </span>
  </div>
</template>

<script>
export default {
  name: 'HomeCollectionsInputItem',
  props: {
    collection: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      titleSeparatorIcons: [
        { value: 'https://cdn.goxip.com/icons/header-what-to-buy-now.png', label: 'Heart' },
        { value: 'https://cdn.goxip.com/icons/header-magazine.png', label: 'Eye' },
      ],
    }
  },
  computed: {
    bannerIds: {
      get() {
        return this.collection.banner_ids
      },
      set(newValue) {
        const deepCopyCollection = JSON.parse(JSON.stringify(this.collection))
        deepCopyCollection.banner_ids = newValue
        this.$emit('update', deepCopyCollection)
      },
    },
    title: {
      get() {
        return this.collection.title
      },
      set(newValue) {
        const deepCopyCollection = JSON.parse(JSON.stringify(this.collection))
        deepCopyCollection.title = newValue
        this.$emit('update', deepCopyCollection)
      },
    },
    titleHK: {
      get() {
        return this.collection.title_zh_hk
      },
      set(newValue) {
        const deepCopyCollection = JSON.parse(JSON.stringify(this.collection))
        deepCopyCollection.title_zh_hk = newValue
        this.$emit('update', deepCopyCollection)
      },
    },
    titleCN: {
      get() {
        return this.collection.title_zh_cn
      },
      set(newValue) {
        const deepCopyCollection = JSON.parse(JSON.stringify(this.collection))
        deepCopyCollection.title_zh_cn = newValue
        this.$emit('update', deepCopyCollection)
      },
    },
    titleTH: {
      get() {
        return this.collection.title_th_th
      },
      set(newValue) {
        const deepCopyCollection = JSON.parse(JSON.stringify(this.collection))
        deepCopyCollection.title_th_th = newValue
        this.$emit('update', deepCopyCollection)
      },
    },
    image: {
      get() {
        const selectedIcon = this.titleSeparatorIcons.find(icon => icon.value === this.collection.image)
        if (typeof selectedIcon === 'object') {
          return selectedIcon.value
        }
        return null
      },
      set(newValue) {
        const deepCopyCollection = JSON.parse(JSON.stringify(this.collection))
        deepCopyCollection.image = newValue
        this.$emit('update', deepCopyCollection)
      },
    },
    isBannerIdsInput() {
      return this.collection.type.inputType === 'bannerIds'
    },
    isTitleSeparatorInput() {
      return this.collection.type.inputType === 'titleSeparator'
    },
  },
}
</script>

<style lang="scss" scoped>
</style>

